import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Card, Column, Row, TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIsMobileForHomePage } from '~/hooks/useIsMobileForHomePage';
import { useLocaleKeys } from '~/i18n';
import styles from './NeedsAttentionCard.module.scss';
export const GetNeedsAttentionCardTID = (parentTestId)=>getTestIds(parentTestId);
export function NeedsAttentionCard(param) {
    let { items, onItemAction } = param;
    const { NeedsAttentionCardTestIds: TID } = useMemo(()=>GetNeedsAttentionCardTID(), []);
    const { t: texts } = useLocaleKeys('pages.clientDetail.summary.needsAttention');
    const isMobile = useIsMobileForHomePage();
    const ItemLayout = isMobile ? Column : Row;
    if (items.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Card, {
        bi: {
            name: 'client_detail_needs_attention_card'
        },
        testId: TID.Root(),
        padding: "m",
        borderRadius: "m",
        className: styles.card,
        title: texts.title({
            count: items.length
        }),
        disableSeparator: true,
        children: /*#__PURE__*/ _jsx(Column, {
            gap: 12,
            children: items.map((item)=>/*#__PURE__*/ _jsx(Box, {
                    testId: TID.Item(item.id),
                    className: styles.item,
                    children: /*#__PURE__*/ _jsxs(ItemLayout, {
                        gap: isMobile ? 4 : 12,
                        alignItems: isMobile ? 'start' : 'center',
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                children: item.message
                            }),
                            /*#__PURE__*/ _jsx(TextButton, {
                                bi: {
                                    name: 'client_detail_needs_attention_action'
                                },
                                testId: TID.Action(item.id),
                                skin: "primary",
                                underline: "none",
                                onClick: ()=>onItemAction(item.id),
                                children: item.actionLabel
                            })
                        ]
                    })
                }, item.id))
        })
    });
}
